import { FileTextIcon } from '@phosphor-icons/react';
import React from 'react';

import { useDocumentacionExtra } from '../../../hooks/Reintegro/Documentacion/useDocumentacionExtra';
import { iconSiniestroProps } from '../../../pages/siniestro';
import Alert from '../../UI/Alert';
import Button from '../../UI/Button';
import CameraActionSheet from '../../UI/CameraActionSheet';
import FileUploader from '../../UI/FileUploader';
import FormHeader from '../../UI/FormHeader';
import Gallery from '../../UI/Gallery';

interface DocumentacionExtraProps {
  siniestroId: string;
  onClose: () => void;
}

const DocumentacionExtra: React.FC<DocumentacionExtraProps> = ({
  siniestroId,
  onClose,
}) => {
  const {
    selectedFileType,
    pendingFiles,
    hasPendingFiles,
    isUploading,
    showGallery,
    selectedGalleryFile,
    LABELS,
    cameraPicker,
    alertState,
    hideAlert,
    handleUpload,
    handleCancel,
    openGallery,
    closeGallery,
    handleDeleteFromGallery,
    handleFileUploaderClick,
  } = useDocumentacionExtra({ siniestroId, onClose });

  return (
    <div className="documentacion-extra ion-padding">
      <FormHeader
        icon={<FileTextIcon {...iconSiniestroProps} />}
        title="Documentación extra"
        subtitle={
          selectedFileType
            ? `Agregar ${LABELS[selectedFileType].toLowerCase()}`
            : 'Historia clínica y estudios'
        }
      />

      <div style={{ marginTop: '66px' }}>
        {pendingFiles.map((pendingFile, index) => (
          <FileUploader
            key={pendingFile.id}
            fileData={{
              label: `${LABELS[pendingFile.type]} ${index + 1}`,
              isLoading: isUploading,
              uploaded: [pendingFile.preview],
              counter: 1,
              disabled: isUploading,
              showUploadAction: false,
            }}
            onShowCameraOptions={handleFileUploaderClick}
            onViewFile={() => openGallery(pendingFile.id)}
          />
        ))}

        <FileUploader
          fileData={{
            label: hasPendingFiles ? 'otro Documento' : 'Documento',
            isLoading: false,
            counter: 0,
            disabled: isUploading,
            showUploadedState: false,
          }}
          onShowCameraOptions={handleFileUploaderClick}
          onFileChange={cameraPicker.handlePDFChange}
          inputRefSetter={(el) => (cameraPicker.fileInputRef.current = el)}
        />

        {hasPendingFiles && (
          <Button noMarginTop onClick={handleUpload} disabled={isUploading}>
            {isUploading
              ? 'Subiendo documentos...'
              : `Subir ${pendingFiles.length > 1 ? 'documentos' : 'documento'}`}
          </Button>
        )}

        {hasPendingFiles && (
          <Button fill="clear" onClick={handleCancel}>
            Cancelar
          </Button>
        )}

        {!hasPendingFiles && (
          <Button fill="clear" onClick={onClose}>
            Cerrar
          </Button>
        )}
      </div>

      {cameraPicker.showCameraOptions && (
        <CameraActionSheet
          showCameraOptions
          setShowCameraOptions={(v) =>
            v ? cameraPicker.openCameraOptions() : cameraPicker.closeCameraOptions()
          }
          takePhoto={cameraPicker.handleCamera}
          selectFromGallery={cameraPicker.handleGallery}
          uploadPDF={cameraPicker.handlePDFClick}
        />
      )}

      {showGallery && selectedGalleryFile && (
        <Gallery
          isOpen
          onClose={closeGallery}
          fileUrl={selectedGalleryFile.preview}
          mimeType={selectedGalleryFile.mimeType}
          title={LABELS[selectedGalleryFile.type]}
          allowDelete
          onDelete={handleDeleteFromGallery}
        />
      )}

      <Alert {...alertState} onDidDismiss={hideAlert} />
    </div>
  );
};

export default DocumentacionExtra;
